import { create } from 'zustand';
import { api, setUnauthorizedHandler } from '../lib/api';

export interface AuthUser {
  id: string;
  username: string;
  email: string;
}

interface AuthState {
  user: AuthUser | null;
  /** 'loading' until the first /me check finishes. */
  status: 'loading' | 'anonymous' | 'authenticated';
  checkSession: () => Promise<void>;
  login: (identifier: string, password: string) => Promise<void>;
  register: (username: string, email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'loading',

  checkSession: async () => {
    try {
      const { user } = await api.get<{ user: AuthUser }>('/api/auth/me');
      set({ user, status: 'authenticated' });
    } catch {
      set({ user: null, status: 'anonymous' });
    }
  },

  login: async (identifier, password) => {
    const { user } = await api.post<{ user: AuthUser }>('/api/auth/login', { identifier, password });
    set({ user, status: 'authenticated' });
  },

  register: async (username, email, password) => {
    const { user } = await api.post<{ user: AuthUser }>('/api/auth/register', { username, email, password });
    set({ user, status: 'authenticated' });
  },

  logout: async () => {
    try {
      await api.post('/api/auth/logout');
    } finally {
      set({ user: null, status: 'anonymous' });
    }
  },
}));

setUnauthorizedHandler(() => useAuthStore.setState({ user: null, status: 'anonymous' }));
